<template>
  <div class="wechatBindPage">
      <div class="login-bg" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
        <img :src="headPic" alt="">
        <div class="bouns">            
            
        </div>
      </div>

      <mu-list v-if="!loaded">
        <mu-list-item  title="手机绑定" @click="bindType(1)">
          <mu-icon slot="left" value=":fa fa-member2"/>
          <mu-icon slot="right" value=":fa fa-angle-right"/>
        </mu-list-item>
        <mu-divider shallowInset/>
        <mu-list-item title="账号绑定" @click="bindType(2)">
          <mu-icon slot="left" value=":fa fa-people3"/>
          <mu-icon slot="right" value=":fa fa-angle-right"/>
        </mu-list-item>
      </mu-list>
      
      <div class="bindForm" v-if="mobileBind">
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-text-field label="手机号" icon=":fa fa-phone" labelFloat fullWidth v-model="mobileBindDto.mobile" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="70" tablet="75" desktop="33">
            <mu-text-field label="短信验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-envelope-o" labelFloat fullWidth v-model="mobileBindDto.code" />
          </mu-col>
          <mu-col width="30" tablet="25" desktop="33">      
            <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33" class="login-div bindBtn">
            <mu-raised-button label="绑 定" class="demo-raised-button" primary fullWidth @click="MobileBindSubmit()" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33" class="login-div">
            <mu-raised-button label="取 消" class="demo-raised-button" fullWidth @click="backBind()" />
          </mu-col>
        </mu-row>
      </div>
      
      <div class="bindForm" v-if="accountBind">
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-text-field label="用户名" icon=":fa fa-user" labelFloat fullWidth v-model="accountBindDto.UserName" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33">
            <mu-text-field label="密码" type="password" helpText="请输入密码" icon=":fa fa-lock" labelFloat fullWidth v-model="accountBindDto.password" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33" class="login-div bindBtn">
            <mu-raised-button label="绑 定" class="demo-raised-button" primary fullWidth @click="AccountBindSubmit()" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="50" desktop="33" class="login-div">
            <mu-raised-button label="取 消" class="demo-raised-button" fullWidth @click="backBind()" />
          </mu-col>
        </mu-row>
      </div>

      <XR-toast @onClose="goIndex()" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      loaded:true,
      headPic:'' ,
      mobileBind:false,
      accountBind:false,
      smsBtnText:'获取短信',
      mobileBindDto:{
        mobile:'',
        code:'',
      },
      accountBindDto:{
        UserName:'',
        password:''
      },
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted(){
    var accesstoken = this.$route.query.accesstoken
    if(accesstoken){
      this.$store.dispatch('SetUser', accesstoken)
    }
    var openId = this.$route.query.openId
    if(openId){
      this.$store.dispatch('SETWeChat', openId)
    }
    var sessionId = this.$store.state.user.SessionId
    if(sessionId){
      this.isLogin = true
    }
    
    if (!this.$store.state.user.SessionId) {
      this.loginUrl = "/Login";
      return;
    }
    this.getSiteInfo()
    this.getIndexInfo()
  },
  methods: {
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },   
    getIndexInfo(){      
      const ths = this;
      this.$post("/Shop/UserServer/GetUserInfo")
      .then(function(res) {
        ths.loaded =false
        if (res.IsSuccess) {         
          ths.headPic = res.Data.HeadPic 
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    bindType(type){
      this.mobileBind =false
      this.accountBind = false
      this.loaded = true
      if(type == 1){
        this.mobileBind =true
      }else{
        this.accountBind = true
      }
    },
    backBind(){
      this.mobileBind =false
      this.accountBind = false
      this.loaded = false
    },
    MobileBindSubmit(){
      const ths = this;
      this.$post('/Shop/UserServer/WeChatBindMobile', this.mobileBindDto)
        .then(function (res) {
          ths.$refs.XRtoast.hide()
          if(res.IsSuccess){
            ths.$refs.XRtoast.success(res.Msg, true)  
          }else{
            ths.mobileBindDto.mobile = ''
            ths.mobileBindDto.code = ''
            ths.$refs.XRtoast.failed(res.Msg, true)            
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    AccountBindSubmit(){
      this.accountBindDto.password = md5(this.accountBindDto.password)

      const ths = this;
      this.$post('/Shop/UserServer/WeChatBindAccount', this.accountBindDto)
        .then(function (res) {
          ths.$refs.XRtoast.hide()
          if(res.IsSuccess){
            ths.$refs.XRtoast.success(res.Msg, true)  
          }else{
            ths.accountBindDto.UserName = ''
            ths.accountBindDto.password = ''
            ths.$refs.XRtoast.failed(res.Msg, true)            
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    
    getSmsCode: function(){
      const ths = this;
      ths.$refs.XRtoast.load("正在处理...")
      this.$post('/Shop/UserServer/WeChatBindMobileSendSms',JSON.stringify({mobile:this.mobileBindDto.mobile}))
        .then(function (res) {
          ths.$refs.XRtoast.hide()
          if(res.IsSuccess){
            ths.smsBtnText = res.Data * 60;
            var interval = setInterval(function(){
              if(ths.smsBtnText >0){
                ths.smsBtnText--
              }else{
                ths.smsBtnText = '获取短信'
                clearInterval(interval)
              }
            }, 1000)  
          }else{
            ths.$refs.XRtoast.failed(res.Msg, true)            
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    goIndex(){
      window.location.href=this.MOBILE_URL + "/wechat.aspx";
    }
  }
}
</script>
<style>
body .wechatBindPage{
    background: #eee;
}
.wechatBindPage .mu-list{
  background: #fff;
}
.wechatBindPage .mu-item-content{
  display: flex;
}
.wechatBindPage .mu-item-left .fa{
  font-size: 24px;
  width: auto;
}

.wechatBindPage .mu-item-title{
  font-size: 16px;
}
.wechatBindPage .mu-avatar-inner,.wechatBindPage  .mu-tabs{
  width: 20px;
  height: 18px;
  background: red;
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
}
.wechatBindPage .mu-list .mu-item-right .fa-angle-right{
  font-size: 24px;
}
 .wechatBindPage .login-bg {
    width: 100%;
    height: 135px;
    position: relative;
    text-align: center;
    justify-content: center;
    background: url('/static/us-top-bg.png');
    background-size: 100% 100%;
}
.wechatBindPage .demo-flat-button{
    background: red;
    position: absolute;
    border: 0;
    top: 10px;
    right: 10px;
    color: #fff;
 }
.wechatBindPage .mu-flat-button{
   min-width: 60px;
    height: 25px;
    line-height: 25px;
 } 
.wechatBindPage .bouns{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 15px 15px 0 0;
}
.wechatBindPage .bouns p{
  font-size: 16px;
  color: #696969;
}
 .wechatBindPage .login-bg img{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
  top: 45px;
  z-index: 1;
}
.wechatBindPage .num{
  margin-top: 20px;
}
.wechatBindPage .num .count{
  font-size: 20px;
  color: #696969;
}
.wechatBindPage .num .text{
  font-size: 12px;
  color: #b2b2b2;
}

.salesmandailizhongxing .bottom-nav{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.wechatBindPage .bindForm {
  padding: 10px 20px 20px 10px;
  background: white;
}
.wechatBindPage .login-div {
  padding: 20px 0px 0 20px;
}
.wechatBindPage .login-div.bindBtn {
  padding-top: 40px;
}
.wechatBindPage .demo-raised-button {
  height: 50px;
}
.wechatBindPage .div2 {
  padding: 20px 0 0 0;
}
.wechatBindPage .demo-flat-button.right {
  float: right;
}
.wechatBindPage .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
.wechatBindPage .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/wechatBind.vue